/**
 * @summary - Component that Provides Asset Type Code Edit Page
 * @author Yuvasri S
 * @since 2024-05-28
 */
import React, { useState, useEffect } from "react";
import { Box, Grid, Button } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import { useNavigate, useLocation } from "react-router";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import {
    getAuthToken,
    getcompanyId,
    getFacilityId,
    getCreatedBy,
    getModifiedBy,
} from "../../utility/tokenUtility";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import PageTitle from "../commoncomponents/PageTitle";

const ViewAssetTypeCode = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [service, setService] = useState("");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [classification, setClassification] = useState("");
    const [classificationOptions, setClassificationOptions] = useState([]);
    const [category, setCategory] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [categoryDesc, setCategoryDesc] = useState("");
    const [typecode, setTypeCode] = useState("");
    const [typedescription, setTypeCodeDesc] = useState("");
    const [typecodeId, setTypeCodeId] = useState("");
    const [readOnly, setReadOnly] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isView, setIsView] = useState(false);

    useEffect(() => {
        const fetchInitialData = async () => {
            if (location.state) {
                const {
                    serviceId,
                    serviceName,
                    assetclassification,
                    assetclassificationId,
                    assetcategory,
                    assetcategoryId,
                    assetCategoryDescription,
                    typecode,
                    typeDescription,
                    typecodeId,
                    readOnly,
                    readOnlyEdit,
                    mode,
                } = location.state;

                const selectedService = serviceOptions.find(
                    (option) => option.label === serviceName
                );
                const selectedClassification = classificationOptions.find(
                    (option) => option.label === assetclassification
                );
                const selectedCategory = categoryOptions.find(
                    (option) => option.label === assetcategory
                );

                setService(
                    selectedService
                        ? selectedService
                        : { value: serviceName, label: serviceName, id: serviceId }
                );
                setClassification(
                    selectedClassification
                        ? selectedClassification
                        : {
                            value: assetclassification,
                            label: assetclassification,
                            id: assetclassificationId,
                        }
                );
                setCategory(
                    selectedCategory
                        ? selectedCategory
                        : {
                            value: assetcategory,
                            label: assetcategory,
                            id: assetcategoryId,
                        }
                );
                setCategoryDesc(assetCategoryDescription);
                setTypeCode(typecode);
                setTypeCodeDesc(typeDescription);
                setTypeCodeId(typecodeId);
                setReadOnly(!!readOnly);
                setIsView(true);
            }
        };

        fetchInitialData();
    }, [location.state]);

    const handleCancel = () => {
        navigate(-1, { replace: true });

    };
    const handleCategoryChange = () => {

    }

    return (
        <>
            <PageTitle
                title={"View Asset Type Code"}
            />

            <DefaultCard sx={{ height: "100%" }}>
                <form style={{ position: "relative" }}>
                    <Grid container gap={3}>
                        <Grid item xs={6} md={3.8}>
                            <CustomSelectInput
                                id="service-label"
                                label="Service"
                                value={service}
                                options={serviceOptions}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomSelectInput
                                maxlength={10}
                                id="classification-label"
                                label="Asset Classification"
                                value={classification}
                                options={classificationOptions}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextFieldWithSearch
                                label="Asset Category"
                                id="asset-category"
                                value={category}
                                options={categoryOptions}
                                onChange={handleCategoryChange}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={225}
                                label="Asset Category Description"
                                id="category-desc"
                                value={categoryDesc}
                                disabled={true}
                                placeholder=""
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={10}
                                label="Type Code"
                                id="type-code"
                                value={typecode}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={255}
                                label="Type Code Description"
                                id="type-code-description"
                                value={typedescription}
                                disabled={true}
                            />
                        </Grid>
                    </Grid>
                </form>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: { xs: "center", md: "end" },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                            Back
                        </Button>
                    </Box>
                </Box>
            </DefaultCard>
        </>
    );
};

export default ViewAssetTypeCode;
